<template>
  <v-main>
    <v-container>
      <br />
      <v-row justify="start">
        <v-col style="min-width: 105px">
          <span class="text-h5 font-weight-bold" v-text="'Blogs'"></span>
          <addbutton :link="'/blogs/create'"></addbutton>
        </v-col>
      </v-row>
      <loader v-if="isLoading"></loader>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left sr_no_class">Sr No</th>
                    <th class="text-left" style="min-width: 57px">Title</th>
                    <th class="text-left" style="min-width: 95px">
                      Description
                    </th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(blog, i) in blogs" :key="`blog_${i}`">
                    <td>{{ i + 1 }}</td>
                    <td>{{ blog.title }}</td>
                    <td v-html="blog.description"></td>
                    <td class="text-right" style="min-width: 160px">
                      <v-btn
                        class="mx-2"
                        x-small
                        color="primary"
                        :to="`/blogs/${blog.id}/blog-details`"
                      >
                        details
                      </v-btn>
                      <v-btn
                        fab
                        x-small
                        color="primary"
                        :to="`/blogs/${blog.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import addbutton from "@/components/addbutton.vue";
import Loader from "@/components/loader.vue";
export default {
  name: "BlogsPage",
  data() {
    return {
      blogs: [],
      isLoading: false,
    };
  },
  components: {
    addbutton,
    Loader,
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let blogs = await axios.get(`blogs`);
      this.blogs = blogs.data.data;
      this.isLoading = false;
    },
  },
};
</script>
